/**
 * Configuration for normalized price range slider (0-100 scale)
 */
export const FilterRangeNormalizedConfig = {
  MIN: 0,
  MAX: 100,
  STEP: 0.01,
} as const;

/**
 * Configuration for stepped range filters
 */
export const SteppedRangeConfig = {
  /**
   * Maximum number of discrete values to use SteppedRange strategy.
   * Above this limit, use ContinuousRange for performance.
   *
   * Examples:
   * - RAM: [4, 8, 16, 32, 64] → 5 values → SteppedRange ✓
   * - Screen sizes with 100+ values → ContinuousRange
   */
  MAX_STEPS: 100,
} as const;
